import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Navbar as BootstrapNavbar, Nav, Container, NavDropdown, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './Navbar.scss';
const Navbar = ({ brand = 'Growth Blocks', variant = 'light', expand = 'lg', className = '', onLoginClick, onLogoutClick, isAuthenticated = false, user }) => {
    const [expanded, setExpanded] = useState(false);
    const navigate = useNavigate();
    const handleToggle = () => setExpanded(!expanded);
    const handleClose = () => setExpanded(false);
    const handleSettingsClick = () => {
        navigate('/settings');
        handleClose();
    };
    const handleLogoutClick = () => {
        if (onLogoutClick) {
            onLogoutClick();
        }
        handleClose();
    };
    return (_jsx(BootstrapNavbar, { bg: variant, variant: variant, expand: expand, className: `custom-navbar ${className}`, expanded: expanded, onToggle: handleToggle, children: _jsxs(Container, { fluid: true, children: [_jsx(BootstrapNavbar.Brand, { href: "/", className: "fw-bold", children: brand }), _jsx(BootstrapNavbar.Toggle, { "aria-controls": "basic-navbar-nav" }), _jsxs(BootstrapNavbar.Collapse, { id: "basic-navbar-nav", children: [_jsxs(Nav, { className: "me-auto", children: [_jsx(Nav.Link, { href: "/", onClick: handleClose, children: "Home" }), _jsx(Nav.Link, { href: "/documentation", onClick: handleClose, children: "Documentation" })] }), _jsx(Nav, { children: isAuthenticated && user ? (_jsxs(NavDropdown, { title: user.name, id: "user-nav-dropdown", align: "end", children: [_jsx(NavDropdown.Item, { onClick: handleSettingsClick, children: "Settings" }), _jsx(NavDropdown.Divider, {}), _jsx(NavDropdown.Item, { onClick: handleLogoutClick, children: "Logout" })] })) : (_jsx(Button, { variant: "outline-primary", onClick: onLoginClick, children: "Login" })) })] })] }) }));
};
export default Navbar;
